export const methode = {
  title: 'Blink Nederlands Jaar 3 Havo/VWO',
  image: './img/blink-nederlands.png',
  children: {
    'Startles': {
      children:{
        'Wat is Nederlands?':{
          image:'//lh3.googleusercontent.com/FUdW2d_E2L92SVJzoJOeTWxfACWUGqsypomDyYeOamPsAhrE_e0y8O86G3wQeL2e4vRxmXXGJCxioCsAsQLRcvTCkotU=w160-h170-c',
        }
      }
    },
    'Dossier Rein de V.':{
      class:'type-story',
      description:'Rein de V. staat bekend als de grootste crimineel van zijn tijd. Keer op keer slaat hij toe, maar steeds komt hij er mee weg. Jij zoekt uit wie hij is, wat hij gedaan heeft, of hij schuldig is en zo ja, wat een passende straf is voor Rein de V. Je sluit af met een eindopdracht.',
      children:{
        'Black Story':{
          image:'//lh3.googleusercontent.com/kJpazTehgDm1kKbxid2CznX9FL8CqxHiiw5bQLyCdnXaTgcATo7SiUWE3oPUplrPDR-lrnrGvJgpi7aw8nNaSPKqwk4u5bOSP8g4dDO0=w150-h150-c',
        },
        'Modus operandi':{
          image:'//lh3.googleusercontent.com/C8MZq7TQosU1kzXpK-o-3GWeedmhFQjiXHeXQ1HCX2GzT3UgiYQzeHTFXYpi2XFL2BUstRCarj8mdo6TyVLVmjoIlk9Peya6cpiRl0UE=w150-h150-c',
        },
        'Mooipraterij':{
          image:'//lh3.googleusercontent.com/XhuWy_zlEsEBrMrJH6Ly7QCFVfcJ3H9n1I4oBBQ7Z9UNFD8WbZbiYcE15INBrK250WgKetj90J6JMtt5nqUpwSb_Xu0vLAfRVRvYwsIu=w150-h150-c',
        }, 
        'Geen genade':{
          image:'//lh3.googleusercontent.com/VJALi9yKx35wBpgPzh-2ztFIT-ECLg9-PlV5-HsvVAly0IJI43b5guz_5LMbSGuQrUozliIb2Oj8tFu_R1YjXy5Zkuv5XZlb57nRf8wp=w150-h150-c',
        },
        'Crimineel of boef?':{
          image:'//lh3.googleusercontent.com/GcORihr_KUEMIcoiuxumq6NQ551ssHlcz-QjDUbOrcgIBH24KV388yrFaSK_1hLKcHHZH6heo2_GVNvvD5x3wEErpnfUD_gJlGwhTvo=w150-h150-c',
        },
        'De afloop (1)':{
          image:'//lh3.googleusercontent.com/dKELqj0d5fZB9Sd6WFVwm1SViE1R_1GExQbTn8K1dcICKWnW5kPI8kLc5yAdZLGbYHy4bkham1dNFcsBRTHDLgL54MMnwaPtDA4rfYAM6A=w150-h150-c',
        },
        'De afloop (2)':{
          image:'//lh3.googleusercontent.com/RvZp8SYgdw0Z41RCidartUUpLJR7EysaOQEd3mlE9Evplx4rNxHg5PfEKU0cPyNnw5sW_l_xSLmRNtLfZWGx8cVq-9AmaPc0akqdG5W27w=w150-h150-c',
        }
      }
    },
    'Drone': {
      class:'type-story',
      description:'Drone is een ‘hybride’ verhaal: deels werkelijkheid, deels verhaal. De werkelijkheid is dat we dagelijks heel veel informatie krijgen die we voortdurend bewust en onbewust filteren: wat is waar en wat is niet waar, wat vind ik ervan, wat vinden anderen ervan, hoe vorm ik mijn mening en mijn oordeel en hoe verwoord ik dat? Het verhaal gaat over voormalig F16-piloot Victor D., die voor een onmogelijke keuze wordt gesteld. Door zijn keuze sterven vijf Nederlandse soldaten tijdens hun missie. De vragen die de leerlingen gaan beantwoorden: is Victor D. schuldig en welke invloed spelen de media bij dit oordeel?',
      children: {
        'Les 1': {
          image: '//lh3.googleusercontent.com/xZoYaevDkEC0Lnz4MKuVb-RlOU2rmSlrt0DWNWX3TfF40kCovKnnN-n-t9jF94rjOwmjOB4JbSgq8jGShlAJ7lbWoso=w160-h170-c',
        },
        'Les 2': {
          image: '//lh3.googleusercontent.com/xZoYaevDkEC0Lnz4MKuVb-RlOU2rmSlrt0DWNWX3TfF40kCovKnnN-n-t9jF94rjOwmjOB4JbSgq8jGShlAJ7lbWoso=w160-h170-c',
        },
        'Les 3': {
          image: '//lh3.googleusercontent.com/xZoYaevDkEC0Lnz4MKuVb-RlOU2rmSlrt0DWNWX3TfF40kCovKnnN-n-t9jF94rjOwmjOB4JbSgq8jGShlAJ7lbWoso=w160-h170-c',
        },
        'Les 4': {
          image: '//lh3.googleusercontent.com/xZoYaevDkEC0Lnz4MKuVb-RlOU2rmSlrt0DWNWX3TfF40kCovKnnN-n-t9jF94rjOwmjOB4JbSgq8jGShlAJ7lbWoso=w160-h170-c',
        },
        'Les 5': {
          image: '//lh3.googleusercontent.com/xZoYaevDkEC0Lnz4MKuVb-RlOU2rmSlrt0DWNWX3TfF40kCovKnnN-n-t9jF94rjOwmjOB4JbSgq8jGShlAJ7lbWoso=w160-h170-c',
        },
        'Les 6': {
          image: '//lh3.googleusercontent.com/xZoYaevDkEC0Lnz4MKuVb-RlOU2rmSlrt0DWNWX3TfF40kCovKnnN-n-t9jF94rjOwmjOB4JbSgq8jGShlAJ7lbWoso=w160-h170-c',
        },
        'Les 7': {
          image: '//lh3.googleusercontent.com/xZoYaevDkEC0Lnz4MKuVb-RlOU2rmSlrt0DWNWX3TfF40kCovKnnN-n-t9jF94rjOwmjOB4JbSgq8jGShlAJ7lbWoso=w160-h170-c',
        }
      }
    }
  }
 
}